import React, { useState, useEffect, useRef } from "react";
import UnassignStatusProgressComponent from "./unassignStatusProgress.component";
import { useDispatch, useSelector } from "react-redux";
import { getUnassignProgress } from "modules/serial-number/redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { UNASSIGN_BATCH_STATUS_PROCESSING } from "modules/serial-number/constants";

function UnassignStatusProgressContainer({
  unassignId,
  initialProgress = 0,
  initialStatus,
}) {
  const lang = useSelector((state) => state.constant.languages);
  const [status, setStatus] = useState(initialStatus);
  const [progress, setProgress] = useState(initialProgress);
  const dispatch = useDispatch();

  const intervalRef = useRef(null);

  useEffect(() => {
    if (initialStatus === UNASSIGN_BATCH_STATUS_PROCESSING) {
      intervalRef.current = setInterval(() => {
        getData();
      }, 5000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, unassignId]);

  const getData = () => {
    dispatch(getUnassignProgress(unassignId))
      .then(unwrapResult)
      .then((data) => {
        setStatus(data.status);
        setProgress(data.progress);

        if (data.status !== UNASSIGN_BATCH_STATUS_PROCESSING) {
          clearInterval(intervalRef.current);
        }
      })
      .catch(() => {
        setStatus("failed");
        setProgress(0);
        clearInterval(intervalRef.current);
      });
  };

  return (
    <UnassignStatusProgressComponent
      progress={progress}
      status={status}
      lang={lang}
    />
  );
}

export default UnassignStatusProgressContainer;
